(function () {
  function initAnnouncementSlider(root) {
    if (!root || root.__announceInit) return;
    root.__announceInit = true;

    const track = root.querySelector('[data-announcement-track]');
    const items = Array.from(root.querySelectorAll('[data-announcement-item]'));
    if (!track || !items.length) return;

    const interval = Number(root.getAttribute('data-interval')) || 4000;
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = 0;
    let timer = null;

    const goTo = (i, { animate = true } = {}) => {
      index = (i + items.length) % items.length;

      // toggle transition for instant jumps (si quisieras)
      if (!animate) track.style.transition = 'none';
      track.style.transform = `translateX(-${index * 100}%)`;
      if (!animate) {
        // force reflow then restore transition
        track.offsetHeight; // eslint-disable-line no-unused-expressions
        track.style.transition = '';
      }
    };

    const next = () => goTo(index + 1);
    const prev = () => goTo(index - 1);

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (prefersReduced) return;
      stop();
      timer = setInterval(next, interval);
    };

    // init
    goTo(0, { animate: false });
    start();

    // pause on hover/focus
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // controls
    const btnNext = root.querySelector('[data-announce-next]');
    const btnPrev = root.querySelector('[data-announce-prev]');
    if (btnNext) btnNext.addEventListener('click', () => { next(); start(); });
    if (btnPrev) btnPrev.addEventListener('click', () => { prev(); start(); });

    // Recalcular al resize (por si cambian fuentes / padding)
    window.addEventListener('resize', () => goTo(index, { animate: false }));
  }

  function boot(ctx) {
    (ctx || document).querySelectorAll('[data-announcement-slider]').forEach(initAnnouncementSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:select', (e) => boot(e.target));
})();
